var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.756 33.409V14.9531H16.6315V27.0296C19.0616 28.1283 20.756 30.5679 20.756 33.409Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8504 33.409H41.855V14.9531H37.7311V27.1201C40.1349 28.207 41.8145 30.6072 41.8504 33.409Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6315 8.25H16.6095V14.9511H16.6315H20.756H37.731H41.855V8.25H37.731H20.756H16.6315Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7311 27.1165C36.8515 26.7189 35.8787 26.4922 34.8518 26.4922C30.9843 26.4922 27.8494 29.6271 27.8494 33.4953C27.8494 37.3633 30.9843 40.4982 34.8518 40.4982C38.719 40.4982 41.855 37.3633 41.855 33.4953C41.855 33.465 41.8504 33.4358 41.8504 33.4053C41.8145 30.6036 40.1349 28.2034 37.7311 27.1165Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.753 26.4062C9.88579 26.4062 6.75 29.5412 6.75 33.4094C6.75 37.2773 9.88579 40.4122 13.753 40.4122C17.6202 40.4122 20.756 37.2773 20.756 33.4094C20.756 30.5684 19.0617 28.1288 16.6315 27.03C15.7527 26.6326 14.7799 26.4062 13.753 26.4062Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicIcon);
export default __webpack_public_path__ + "static/media/musicIcon.f8b15b93b98f4cc84d7c5f357f632c4a.svg";
export { ForwardRef as ReactComponent };